<template lang="pug">
    title-modal-layout.update-media-vault-album-modal(v-bind="$attrs" title="Change Album Title" :disableCancelButton="true" @approve="save" ref="modal")
        template(v-slot:section)
            input-box-field(label="Album Title" v-model="albumTitle" :v="$v.albumTitle")
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import MediaVaultService from '../../services/media-vault-service'

export default {
    name: 'update-media-vault-album-modal',

    props: {
        album: {
            type: Object,
            required: true,
        },
        updated: {
            type: Function,
        },
    },

    data() {
        return {
            albumTitle: '',
        }
    },

    validations: {
        albumTitle: {
            required,
        },
    },

    methods: {
        save() {
            this.$v.$touch()

            if (!this.$v.$invalid) {
                MediaVaultService.updateAlbum(this.album.id, {
                    name: this.albumTitle,
                }).then(r => {
                    this.updated(r.data)
                    this.$refs.modal.close()
                })
            }
        },
    },

    created() {
        this.albumTitle = this.album.name
    },
}
</script>
